import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgClockIconSecondary from './svgs/ClockIconSecondary.js';
import SvgClockIcon from './svgs/ClockIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var clockIcon = (props => useIcon(SvgClockIcon, SvgClockIconSecondary, props));

export { clockIcon as default };
